import { useEffect } from "react";
import { buildStyleVars } from "@/lib/fonts";

// Applies the invitation's color palette to <html> so the whole page chrome
// (body background, letterbox area, editor shell) matches the uploaded image.
export function useThemeVars(customStyle) {
  useEffect(() => {
    if (!customStyle) return;
    const vars = buildStyleVars(customStyle);
    const keys = Object.keys(vars).filter((k) => k.startsWith("--c-"));
    if (!keys.length) return;
    const root = document.documentElement;
    keys.forEach((k) => root.style.setProperty(k, vars[k]));
    return () => keys.forEach((k) => root.style.removeProperty(k));
  }, [customStyle]);
}
